import { createAction } from '@reduxjs/toolkit';
import { UserState } from './state';

export const updateUserPreferences = createAction(
  'user/UPDATE_USER_PREFERENCES',
  (preferenceName: keyof UserState, preferenceValue: unknown) => ({
    payload: {
      preferenceName,
      preferenceValue,
    },
  }),
);

export const signInByTokenReset = createAction('user/SIGN_IN_BY_TOKEN/reset');

export const signInPending = createAction('user/SIGN_IN/pending');
export const signInFailed = createAction('user/SIGN_IN/failed', (error: string) => ({
  payload: error,
}));
export const signInSucceed = createAction('user/SIGN_IN/succeed');

export const requestPasswordResetPending = createAction('user/REQUEST_PASSWORD_RESET/pending');
export const requestPasswordResetFailed = createAction('user/REQUEST_PASSWORD_RESET/failed', (error: string) => ({
  payload: error,
}));
export const requestPasswordResetSucceed = createAction('user/REQUEST_PASSWORD_RESET/succeed');

export const updateEmailPending = createAction('user/UPDATE_EMAIL/pending');

export const updateEmailFailed = createAction('user/UPDATE_EMAIL/failed');

export const updateEmailSucceed = createAction<{ email: string }>('user/UPDATE_EMAIL/succeed');

export const signInByTokenPending = createAction('user/SIGN_IN_BY_TOKEN/pending');
export const signInByTokenSucceed = createAction<string | null>('user/SIGN_IN_BY_TOKEN/succeed');
export const signInByTokenFailed = createAction<string>('user/SIGN_IN_BY_TOKEN/failed');

export const signUpViaGooglePending = createAction('user/SIGN_UP_VIA_GOOGLE/pending');
export const signUpViaGoogleSucceed = createAction<{
  id: string;
  email: string;
}>('user/SIGN_UP_VIA_GOOGLE/succeed');
export const signUpViaGoogleFailed = createAction<string>('user/SIGN_UP_VIA_GOOGLE/failed');

export const signUpViaFacebookPending = createAction('user/SIGN_UP_VIA_FACEBOOK/pending');
export const signUpViaFacebookSucceed = createAction<{
  id: string;
  email: string;
}>('user/SIGN_UP_VIA_FACEBOOK/succeed');
export const signUpViaFacebookFailed = createAction<string>('user/SIGN_UP_VIA_FACEBOOK/failed');

export const signUpViaQuizPending = createAction('user/SIGN_UP_VIA_QUIZ/pending');
export const signUpViaQuizSucceed = createAction<{ id: string; email: string }>('user/SIGN_UP_VIA_QUIZ/succeed');
export const signUpViaQuizFailed = createAction<string>('user/SIGN_UP_VIA_QUIZ/failed');
